<template>
  <b-row v-if="parentPath && path" style="height:100%;">
    <b-col md="12" style="height:100%;">
      <b-card
        v-tooltip="uniToolTipTranslation(tooltipText, 'en-US')"
        :style="{
          backgroundColor: coloreSfondo,
          color: coloreTesto,
          borderColor: coloreBordo
        }"
        class="card-panel"
        style="height:100%; margin-bottom: 0px !important"
      >
        <div
          v-if="localPath == '.left'"
          slot="header"
          :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }"
        >
          <!-- Primary Side -->
          {{ uniTranslation("PHE821") }}
        </div>
        <div
          v-if="localPath == '.right'"
          slot="header"
          :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }"
        >
          <!-- Secondary Side -->
          {{ uniTranslation("PHE822") }}
        </div>
        <!-- == MODIFICHE DA LASCIARE DIVERSE == -->

        <FluidPicker :path="path"></FluidPicker>

        <el-checkbox v-model="showFluidFlow">{{ uniTranslation("TRNSL42") }}</el-checkbox>

        <UnidataEditor
          v-if="showFluidFlow"
          :parent-path="path"
          :name="'.flow'"
          :show-input="1"
          :show-output1="!modalitaExpert ? 0 : 1"
          :override-input-class="modalitaExpert ? undefined : 'col-12'"
          :override-output1-class="undefined"
        ></UnidataEditor>

        <UnidataEditor :parent-path="path" :name="'.inletTemperature'"></UnidataEditor>

        <UnidataEditor
          :parent-path="path"
          :name="'.outletTemperature'"
          :show-input="1"
          :show-output1="!modalitaExpert ? 0 : 1"
          :override-input-class="modalitaExpert ? undefined : 'col-12'"
          :override-output1-class="undefined"
        ></UnidataEditor>

        <UnidataEditor
          :parent-path="path"
          :name="'.pressureDrop'"
          :show-input="1"
          :show-output1="!modalitaExpert ? 0 : 1"
          :override-input-class="modalitaExpert ? undefined : 'col-12'"
          :override-output1-class="undefined"
        ></UnidataEditor>

        <div style="margin-top: 10px" class="row" v-if="localPath == '.left' && isSelezione">
          <div class="col-12">
            <label v-tooltip="uniToolTipTranslation('TRNSL214', 'en-US')"
              >{{ uniTranslation("TRNSL214") }} - {{ tolleranzaPdcPrim }}</label
            >
            <el-slider v-model="tolleranzaPdcPrim" :step="sliderStep" />
          </div>
        </div>

        <div style="margin-top: 10px" class="row" v-if="localPath == '.right' && isSelezione">
          <div class="col-12">
            <label v-tooltip="uniToolTipTranslation('TRNSL215', 'en-US')"
              >{{ uniTranslation("TRNSL215") }} - {{ tolleranzaPdcSecon }}</label
            >
            <el-slider v-model="tolleranzaPdcSecon" :step="sliderStep" />
          </div>
        </div>

        <UnidataEditor
          v-if="modalitaExpert"
          :parent-path="path"
          :name="'.foulingFactor'"
        ></UnidataEditor>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import FluidPicker from "../shared/FluidPicker";
import UnidataEditor from "../unidata/UnidataEditor";
import { mapActions, mapGetters } from "vuex";
import { Checkbox, Slider } from "element-ui";
import jsonHelper from "../../shared/jsonHelper";

export default {
  components: {
    FluidPicker,
    UnidataEditor, // <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
    "el-checkbox": Checkbox,
    [Slider.name]: Slider
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      path: null,
      modalitaExpert: false,
      showFluidFlow: false, // <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
      coloreSfondo: "",
      coloreTesto: "",
      coloreBarraTitolo: "",
      coloreTitolo: "",
      coloreSfondoTab: "",
      coloreTestoTab: "",
      coloreBordo: "",
      tolleranzaPdcPrim: 0,
      tolleranzaPdcSecon: 0,
      
      sliderStep: 5,
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects","isSelezione"]),
    ...mapGetters("_colorsModule", ["cardColors"]),

    tooltipText() {
      var tmpPath = this.localPath;
      if (tmpPath.includes(".left")) {
        //Primary Side
        return this.uniTranslation("PHE821", "en-US");
      }
      if (tmpPath.includes(".right")) {
        //Secondary Side
        return this.uniTranslation("PHE822", "en-US");
      }
      return this.uniTranslation("S430", "en-US");
    }
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    },
    cardColors() {
      this.setColors();
    },

    tolleranzaPdcPrim: function(newval /*, oldval*/) {
      this.changeProperty({
        path: this.parentPath + ".bottomSelection.pressureDropTolerancePrimario",
        value: newval
      });
    },
    tolleranzaPdcSecon: function(newval /*, oldval*/) {
      this.changeProperty({
        path: this.parentPath + ".bottomSelection.pressureDropToleranceSecondario",
        value: newval
      });
    }
  },
  mounted: function() {
    var that = this;
    if (this.parentPath && this.localPath) this.path = this.parentPath + this.localPath;
    that.setColors();

    that.modalitaExpert = true; //=> in modo da visualizzare sempre i dati di calcolo!!! => è una sua Richiesta del 20.01.20! !

    this.tolleranzaPdcSecon = jsonHelper.getProperty(
      this.projects,
      this.parentPath + ".bottomSelection.pressureDropToleranceSecondario"
    );
    this.tolleranzaPdcPrim = jsonHelper.getProperty(
      this.projects,
      this.parentPath + ".bottomSelection.pressureDropTolerancePrimario"
    );
  },
  methods: {
    ...mapActions("_prjModule", ["changeProperty"]),
    setColors() {
      var that = this;

      that.coloreSfondo = that.cardColors[0] + " !important"; // 7 elementi. 0=sfondo 1=barra titolo 2=testo 3=colore titolo 4= sfondo tab 5=testo tab 6=testo titolo tab quando selezionata
      that.coloreBarraTitolo = that.cardColors[1];
      that.coloreTesto = that.cardColors[2];
      that.coloreTitolo = that.cardColors[3];
      that.coloreSfondoTab = that.cardColors[4];
      that.coloreTestoTab = that.cardColors[5];
      that.coloreBordo = that.cardColors[6];
    }
  }
};
</script>

<style>
.card .card-header {
  color: transparent;
  background-color: transparent;
  padding: 0px;
}

.el-tabs__item:hover {
  color: #409eff !important;
}
.el-tabs__item {
  background-color: transparent !important;
  color: unset !important;
}
.el-tabs__header {
  background-color: transparent !important;
  color: unset !important;
}
.is-active {
  background-color: transparent;
  color: unset !important;
  font-weight: bold;
}
.el-tabs--border-card {
  color: transparent;
}
.el-tabs .el-tabs--top {
  color: transparent !important;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #409eff !important;
  background-color: #fff !important;
  border-right-color: #dcdfe6;
  border-left-color: #dcdfe6;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item:not(.is-active):not(:hover) {
  color: #909399 !important;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item {
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  border: 1px solid transparent;
  border-top-color: transparent;
  border-top-style: solid;
  border-top-width: 1px;
  border-right-color: transparent;
  border-right-style: solid;
  border-right-width: 1px;
  border-bottom-color: transparent;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-left-color: transparent;
  border-left-style: solid;
  border-left-width: 1px;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  margin: -1px -1px 0;
}
.el-tabs--border-card > .el-tabs__header {
  background-color: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  margin: 0;
}
.el-tabs--border-card > .el-tabs__header {
  background-color: #f5f7fa !important;
  border-bottom: 1px solid #e4e7ed;
  margin: 0;
}
</style>

<!--
<style lang="scss">

div{
  hr{
    margin-bottom: 10px;
    margin-top: 0;
  }
  .radio-unidata{
    display:flex;
    flex-direction: row;
    .radio-container{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-top: 25px;
      padding-left: 10px;
      width:160px;
      label{
        margin-bottom: 0px;
      }
      .el-radio + .el-radio{
        margin-left: 0px
      }
    }
  }
}


</style>
-->
